import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from "./router";

Vue.use(Vuex);

const BASE_URL = process.env.VUE_APP_API_URL;

export default new Vuex.Store({
	state: {
		status: '',
		token: localStorage.getItem('token') || '',
		user: localStorage.getItem('user') || '',
		userModules: JSON.parse(localStorage.getItem('userModules')) || [],
		accounts: [],
		accountSelected: '',
		incidentsList: [],
		ticketsList: [],
		maintenanceContractsList: [],
		contractsList: [],
		clientProductsList: [],
		invoicesList: [],
		workProjectsList: [],
		workshopIncidentList: [],
		provincesList: [],
		cantonsList: [],
		districtsList: [],
		neighborhoodsList: [],
		pendingAuthTickets: [],
		serviceTickets: [],
		projects: [],
	},
	mutations: {
		auth_request(state) {
			state.status = 'loading';
		},
		auth_success(state, payload) {
			state.status = 'success';
			state.token = payload.token;
			state.user = payload.user;
		},
		complete(state) {
			state.status = 'success';
		},
		auth_error(state) {
			state.status = 'error';
		},
		logout(state) {
			state.status = '';
			state.token = '';
			state.user = '';
			state.userModules = '';
			state.accounts = [];
			state.accountSelected = '';
			state.incidentsList = [];
			state.ticketsList = [];
			state.maintenanceContractsList = [];
			state.contractsList = [];
			state.clientProductsList = [];
			state.invoicesList = [];
			state.workProjectsList = [];
			state.workshopIncidentList = [];
			state.provincesList = [];
			state.cantonsList = [];
			state.pendingAuthTickets = [];
			state.serviceTickets = [];
			state.projects = [];
		},
		accounts(state, accounts) {
			state.accounts = accounts;
		},
		select_account(state, account) {
			state.accountSelected = account;
		},
		incidents_list(state, incidents) {
			state.incidentsList = incidents;
		},
		tickets_list(state, tickets) {
			state.ticket = tickets;
		},
		maintenance_contracts_list(state, contracts) {
			state.maintenanceContractsList = contracts;
		},
		contracts_list(state, contracts) {
			state.contractsList = contracts;
		},
		client_products_list(state, client_products) {
			state.clientProductsList = client_products;
		},
		invoices_list(state, invoices_list) {
			state.invoicesList = invoices_list;
		},
		work_projects_list(state, work_projects_list) {
			state.workProjectsList = work_projects_list;
		},
		workshop_incidents_list(state, workshop_incident_list) {
			state.workshopIncidentList = workshop_incident_list;
		},
		provinces_list(state, provinces_list) {
			state.provincesList = provinces_list;
		},
		cantons_list(state, cantons_list) {
			state.cantonsList = cantons_list;
		},
		districts_list(state, districts_list) {
			state.districtsList = districts_list;
		},
		neighborhoods_list(state, neighborhoods_list) {
			state.neighborhoodsList = neighborhoods_list;
		},
		pending_auth_tickets(state, pending_auth_tickets) {
			state.pendingAuthTickets = pending_auth_tickets;
		},
		service_tickets(state, service_tickets) {
			state.serviceTickets = service_tickets;
		},
		projects(state, projects) {
			state.projects = projects;
		}
	},
	actions: {
		login({commit}, user) {
			return new Promise(((resolve, reject) => {
				commit('auth_request');

				axios.post(BASE_URL + 'auth/login/', {Username: user.email, Password: user.password})
					.then(resp => {
						const {token, user, userModules} = resp.data;

						localStorage.setItem('token', token);
						localStorage.setItem('user', JSON.stringify(user));
						localStorage.setItem('userModules', JSON.stringify(userModules));
						axios.defaults.headers.common['Authorization'] = token;
						commit('auth_success', {
							token: token,
							user: JSON.stringify(user),
							userModules: JSON.stringify(userModules)
						});
						resolve(resp);
					})
					.catch(err => {
						const {response} = err;
						commit('auth_error');
						localStorage.removeItem('token');
						localStorage.removeItem('user');
						localStorage.removeItem('userModules');
						reject(response);
					})
			}))
		},
		logout({commit}) {
			return new Promise((resolve, reject) => {
				commit('logout');
				localStorage.removeItem('token');
				localStorage.removeItem('user');
				localStorage.removeItem('userModules');
				delete axios.defaults.headers.common['Authorization'];
				resolve()
			})
		},
		loginAccount({commit}, accountID) {
			return new Promise(((resolve, reject) => {
				commit('auth_request');
				axios.post(BASE_URL + 'account/login-account/', {accountID: accountID.accountID})
					.then(resp => {
						const token = resp.data.token;
						localStorage.setItem('token', token);
						axios.defaults.headers.common['Authorization'] = token;
						commit('select_account', resp.data.account);
						resolve(resp);
					})
					.catch(err => {
						const {response} = err;
					})
			}))
		},
		getIncidents({commit}) {
			commit('incidents_list', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'incidents/list/', {})
					.then(resp => {
						commit('incidents_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getAccounts({commit}) {
			commit('accounts', []);
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'account/list/', {})
					.then(resp => {
						commit('accounts', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
					})
			}))
		},
		signUp({commit}, user) {
			return new Promise(((resolve, reject) => {
				axios.post(BASE_URL + 'auth/create-user/', user)
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						console.log('GetAccounts', err);
						const {response} = err;
						reject(response)
					})
			}))
		},
		createTicket({commit}, ticket) {
			return new Promise(((resolve, reject) => {
				axios.post(BASE_URL + 'incidents/create/', ticket)
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response)
					})
			}))
		},
		getIncidentDetail({commit}, incidentID) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'incidents/detail/', {params: {incidentID: incidentID}})
					.then(resp => {
						resolve(resp.data.incident);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response)
					})
			}))
		},
		getTickets({commit}) {
			commit('tickets_list', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'ticket/list/', {})
					.then(resp => {
						commit('tickets_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getTicketDetail({commit}, ticketId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'ticket/detail/', {params: {ticketId: ticketId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		authTicket({commit}, ticketId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'ticket/auth/', {params: {ticketId: ticketId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		quickAuthTicket({commit}, quickTicket) {
			return new Promise(((resolve, reject) => {
				axios.post(BASE_URL + 'ticket/quick-auth/', quickTicket)
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getMaintenanceContracts({commit}) {
			commit('maintenance_contracts_list', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'maintenance-contract/list/', {})
					.then(resp => {
						commit('maintenance_contracts_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getContracts({commit}) {
			commit('contracts_list', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'contract/list/', {})
					.then(resp => {
						commit('contracts_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getClientProductsList({commit}) {
			commit('client_products_list', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'client-product/list/', {})
					.then(resp => {
						commit('client_products_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getInvoices({commit}) {
			commit('invoices_list', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'invoice/list/', {})
					.then(resp => {
						commit('invoices_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getInvoiceDetail({commit}, invoiceId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'invoice/detail/', {params: {invoiceId: invoiceId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		downloadInvoiceFile({commit}, fileUrl) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'invoice/download/', {params: {fileUrl: fileUrl}, responseType: 'arraybuffer'})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getQuotes({commit}) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'quote/list/', {})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getQuoteDetail({commit}, quoteId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'quote/detail/', {params: {quoteId: quoteId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		authQuote({commit}, quote) {
			console.log(quote);
			return new Promise(((resolve, reject) => {
				let formData = new FormData();
				formData.append('Id', quote.Id);
				formData.append('file', quote.file);
				formData.append('purchaseOrder', quote.purchaseOrder);
				axios.post(BASE_URL + 'quote/auth/', formData, {headers: {'Content-Type': 'multipart/form-data'}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getAccountInfo({commit}) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'account/info/', {})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getWorkProjectsList({commit}) {
			commit('work_projects_list', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'work-project/list/', {})
					.then(resp => {
						commit('work_projects_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getWorkProjectDetail({commit}, workProjectId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'work-project/detail/', {params: {workProjectId: workProjectId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getWorkProjectProducts({commit}, workProjectId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'work-project/products/', {params: {workProjectId: workProjectId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getWorkProjectNotes({commit}, workProjectId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'work-project/notes/', {params: {workProjectId: workProjectId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getWorkProjectInvoices({commit}, workProjectId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'work-project/invoices/', {params: {workProjectId: workProjectId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getWorkProjectZoning({commit}, workProjectId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'work-project/zoning/', {params: {workProjectId: workProjectId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getWorkProjectVisitTickets({commit}, workProjectId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'work-project/visit-tickets/', {params: {workProjectId: workProjectId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getWorkProjectVisitTicketDetail({commit}, visitTicketId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'work-project/visit-ticket-detail/', {params: {visitTicketId: visitTicketId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getWorkProjectVisitTicketAnnotations({commit}, params) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'work-project/visit-ticket-annotations/', {params: params})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getWorkshopIncidentsList({commit}) {
			commit('workshop_incidents_list', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'workshop-incident/list/', {})
					.then(resp => {
						commit('workshop_incidents_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getWorkshopIncidentDetail({commit}, workshopIncidentId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'workshop-incident/detail/', {params: {workshopIncidentId: workshopIncidentId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getProvincesList({commit}) {
			commit('provinces_list', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'address/provinces/', {})
					.then(resp => {
						commit('provinces_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getCantonsList({commit}, provinceId) {
			commit('cantons_list', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'address/cantons/', {params: {provinceId: provinceId}})
					.then(resp => {
						commit('cantons_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getDistrictsList({commit}, cantonId) {
			commit('districts_list', []);
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'address/districts/', {params: {cantonId: cantonId}})
					.then(resp => {
						commit('districts_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getNeighborhoodsList({commit}, districtId) {
			commit('neighborhoods_list', []);
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'address/neighborhoods/', {params: {districtId: districtId}})
					.then(resp => {
						commit('neighborhoods_list', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getPendingAuthTickets({commit}) {
			commit('pending_auth_tickets', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'ticket/pending-auth/', {})
					.then(resp => {
						commit('pending_auth_tickets', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getServiceTickets({commit}, incidentId) {
			commit('service_tickets', []);

			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'incidents/service-tickets/', {params: {incidentId: incidentId}})
					.then(resp => {
						commit('service_tickets', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getServiceTicketDetail({commit}, serviceTicketId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'incidents/service-ticket-detail/', {params: {serviceTicketId: serviceTicketId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getServiceTicketProducts({commit}, serviceTicketId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'incidents/service-ticket-products/', {params: {serviceTicketId: serviceTicketId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		updateAccount({commit}, accountUpdateForm) {
			return new Promise(((resolve, reject) => {
				axios.post(BASE_URL + 'account/update/', accountUpdateForm)
					.then(resp => {
						commit('select_account', resp.data);
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		changePassword({commit}, changePasswordForm) {
			return new Promise(((resolve, reject) => {
				axios.post(BASE_URL + 'auth/change-password/', changePasswordForm)
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		forgotPassword({commit}, forgotPasswordForm) {
			return new Promise(((resolve, reject) => {
				axios.post(BASE_URL + 'auth/forgot-password/', forgotPasswordForm)
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		setPassword({commit}, setPasswordForm) {
			return new Promise(((resolve, reject) => {
				axios.post(BASE_URL + 'auth/set-password/', setPasswordForm)
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		searchCustomerCostCenter({commit}, searchTerm) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'customer-cost-center/search', {params: {searchTerm: searchTerm}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getIncidentInvoices({commit}, incidentId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'incidents/invoices/', {params: {incidentId: incidentId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getDashboardInfo({commit}) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'dashboard/index/')
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getZoningList({commit}) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'zoning/list/', {})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getTravelExpenses({commit}, incidentId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'travel-expense/list/', {params: {incidentId: incidentId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getTravelExpensesByAccount({commit}) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'travel-expense/list/by-account/', {})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getTravelExpenseDetail({commit}, travelExpenseId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'travel-expense/detail/', {params: {travelExpenseId: travelExpenseId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getProjects({commit}) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'project/list/', {})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getListadoEquipos({commit}) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'Listado_Equipos/', {})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getPresupuesto({commit}) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'Presupuestos/', {})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		postCargaEquipos({commit}, equipos) {
			return new Promise(((resolve, reject) => {
				axios.post(BASE_URL + 'Carga_Equipos/', {equipos})
					.then(resp => {
						resolve(resp.data);
						console.log(resp);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
				}))
			},
		getProjectDetail({commit}, projectId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'project/detail/', {params: {projectId: projectId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getSummariesByProject({commit}, projectId) {
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'summary/list-by-project/', {params: {projectId: projectId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		},
		getSummaryDetail({commit}, summaryId){
			return new Promise(((resolve, reject) => {
				axios.get(BASE_URL + 'summary/detail/', {params: {summaryId: summaryId}})
					.then(resp => {
						resolve(resp.data);
					})
					.catch(function (err) {
						const {response} = err;
						reject(response);
					})
			}))
		}
	},
	getters: {
		user: state => state.user,
		isLoggedIn: state => !!state.token,
		authStatus: state => state.status,
		accounts: state => state.accounts,
		accountSelected: state => state.accountSelected,
		incidentsList: state => state.incidentsList,
		ticketsList: state => state.ticketsList,
		maintenanceContractsList: state => state.maintenanceContractsList,
		contractsList: state => state.contractsList,
		clientProductsList: state => state.clientProductsList,
		invoicesList: state => state.invoicesList,
		workProjectsList: state => state.workProjectsList,
		workshopIncidentsList: state => state.workshopIncidentList,
		pendingAuthTicketsList: state => {
			if (state.pendingAuthTickets.length > 5) {
				return state.pendingAuthTickets.slice(0, 5);
			} else {
				return state.pendingAuthTickets;
			}
		}
	}
})

